import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Msq from "@MasterBluePrint/Components/Msq";

import * as React from "react";
import { css } from "styled-components";




type Props = HasProduct;

export interface ProductDetailsNonCancellableNonReturnableStyle {
    nonCancellableNonReturnableContainer?: InjectableCss;
    nonCancellableNonReturnableText?: InjectableCss;
    nonCancellableNonReturnableAnchor?: InjectableCss;

}

export const minMulQtyStyles: ProductDetailsNonCancellableNonReturnableStyle = {
    nonCancellableNonReturnableContainer: {
        css: css`
            font-weight: 600;
            font-size: .85rem;
            margin-top: 1.5rem;
            text-align: center;
            @media screen and (max-width: 991px) {
                display:none;
            }
        `,
    },
    nonCancellableNonReturnableText: {
        css: css`
        font-weight: 400;

        `,
    },
    nonCancellableNonReturnableAnchor: {
        css: css`
        font-size: .85rem;
        font-style: italic;
        color: #002554 !important;
        font-family: 'Lato', sans-serif;
        &:hover {
            text-decoration: underline !important;
            color: #2060AD !important;
        }
        `,
    },
};

const styles = minMulQtyStyles;

const ProductDetailsNonCancellableNonReturnable: React.FC<Props> = ({ product }) => {
    if (!product) {
        return null;
    }


    if (product.properties?.ncnr?.toLowerCase() === "true") {
        return (
            <StyledWrapper {...styles.nonCancellableNonReturnableContainer}>
                <Typography {...styles.nonCancellableNonReturnableText}>
                    <Link {...styles.nonCancellableNonReturnableAnchor} href={String(siteMessage("NonCancellableNonReturnableLink"))} title={String(siteMessage("NonCancellableNonReturnableText"))}>
                        {siteMessage("NonCancellableNonReturnableText")}
                    </Link>
                </Typography>
            </StyledWrapper>
        );
    }
    return <></>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsNonCancellableNonReturnable),
    definition: {
        displayName: "Non-Cancellable Non-Returnable",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],

    },
};
export default widgetModule;